<script setup>
import { ref, reactive, computed, onMounted, defineComponent } from 'vue'
import { showToast, Popup, DatePicker } from 'vant';
import copy from 'copy-to-clipboard'
import { userInfoStore, rewardListStore } from '@/stores/counter.js'
import { getReqData, getAllPaymentAPI, } from '@/util/api'

const ElementPopup = defineComponent(Popup)
const ElementDatePicker = defineComponent(DatePicker)

const userStore = userInfoStore()
const rewardStore = rewardListStore()
const userInfo = computed(() => {
  return userStore.userInfo
})
console.log('【userInfo】', userInfo.value);
const recordParams = ref({
  uid: '',
  uname: '',
  pgid: '',
  stime: '',
  etime: ''
})
const showStartTime = ref(false)
const minDate = ref(new Date(2023, 0, 1))
const maxDate = ref(new Date())
const currentDate = ref(['2025', '10', '01'])
const showEndTime = ref(false)
const tableData = ref('')

const confirmStart = (date) =>{
  console.log('【开始时间】', date);
  const dateType = date.selectedValues[0] + '-' + date.selectedValues[1] + '-' + date.selectedValues[2]
  if (recordParams.value.etime && (new Date(recordParams.value.etime) < new Date(dateType))) {
    recordParams.value.stime = recordParams.value.etime
    recordParams.value.etime = dateType
  } else {
    recordParams.value.stime = dateType
  }
  console.log('【视角】', new Date(dateType));
  showStartTime.value = false
}
const confirmEnd = (date) =>{
  console.log('【开始时间】', date);
  const dateType = date.selectedValues[0] + '-' + date.selectedValues[1] + '-' + date.selectedValues[2]
  if (recordParams.value.stime && (new Date(recordParams.value.stime) > new Date(dateType))) {
    recordParams.value.etime = recordParams.value.stime
    console.log('【recordParams.value.etime】', recordParams.value.etime);
    recordParams.value.stime = dateType
    console.log('【recordParams.value.stime', recordParams.value.stime);
  } else {
    recordParams.value.etime = dateType
  }
  showEndTime.value = false
}
const getAllPayment = () => {
  recordParams.value.uid = userInfo.value.uid
  recordParams.value.uname = userInfo.value.uname
  recordParams.value.pgid = 59
  getAllPaymentAPI(getReqData(recordParams.value)).then(res => {
    if (res.data.code == 0) {
      tableData.value = res.data.data
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}

onMounted(() => {

})
</script>

<template>
  <section class="trade-box">
    <aside style="display: flex; align-items: center; margin: 0.66rem 15px 0rem;">
      <!-- <span class="text-sys2">서버:</span> -->
      <span class="text-sys2">계정:</span>
      <span class="text-sys2" style="width: 150px;">{{ userInfo.uname }}</span>
    </aside>
    <!-- <aside style="display: flex; align-items: center; margin: 8px 15px 0rem;">
      <span class="text-sys2">캐릭터:</span>
      <span class="text-sys2" style="width: 150px;">9527</span>
    </aside> -->
    <aside style="display: flex; align-items: center; margin: 8px 15px 0rem;">
      <span class="text-sys2">총전일시: </span>
      <aside style="display: flex; align-items: center; font-size: 13px; background: #ffffff; border-radius: 6px; padding: 4px 6px; margin-left: 6px;">
        <span @click="showStartTime = true" :class="recordParams.stime ? 'time-text' : 'time-text-no'">{{ recordParams.stime ? recordParams.stime : '시작 시간' }}</span>-
        <span @click="showEndTime = true" :class="recordParams.etime ? 'time-text' : 'time-text-no'">{{ recordParams.etime ? recordParams.etime : '종료 시간' }}</span>
      </aside>
      <button @click="getAllPayment" class="btn-box">검색</button>
    </aside>
    <span style="color: rgb(90, 131, 208); font-size: 14px; margin: 8px 15px 0rem;">{{ '누적요금: ' + (tableData.SUMMONEY ? tableData.SUMMONEY : 0) }}</span>
    <section style="flex: 1; display: flex; flex-direction: column; align-items: center; margin: 12px 15px 36px;">
      <table v-if="tableData" style="background: rgb(255 255 255 / 60%);">
        <thead style="color: rgb(90, 131, 208); background: rgb(235, 235, 235);">
          <tr>
            <td>금액</td>
            <td>서버</td><!--区服-->
            <td>캐릭터</td><!--角色-->
            <!--<td>결제수단</td>支付方式-->
            <td>총전일시</td><!--时间-->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in tableData.data" :key="index">
            <td>{{ list.SHOWMONEY }}</td>
            <td>{{ list.DRNAME + '[' + list.DSID + ']' }}</td>
            <td>{{ list.DRNAME }}</td>
            <td>{{ list.ATIME }}</td>
          </tr>
        </tbody>
      </table>
      <span v-else style="color: #999999; font-size: 14px;">해당하는 검색 결과가 없습니다.</span>
    </section>
    <ElementPopup v-model:show="showStartTime" destroy-on-close round position="bottom">
      <ElementDatePicker
      v-model="currentDate"
      title="날짜 선택"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="confirmStart"
      @cancel="showStartTime = false"
      />
    </ElementPopup>
    <ElementPopup v-model:show="showEndTime" destroy-on-close round position="bottom">
      <ElementDatePicker
      v-model="currentDate"
      title="날짜 선택"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="confirmEnd"
      @cancel="showEndTime = false"
      />
    </ElementPopup>
  </section>
</template>

<style scoped>
.trade-box {
  width: 100%;
  height: 100vh;
  position: relative;
  background: url('../../assets/img/03p/trade-bac.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  flex-direction: column;
}
.text-sys2 {
  font-size: 15px;
  /* font-weight: bolder; */
  color: #ffffff;
  text-shadow: -1px -1px 0 rgb(67, 116, 167), 1px -1px 0 rgb(67, 116, 167), -1px 1px 0 rgb(67, 116, 167), 1px 1px 0 rgb(67, 116, 167);
}
.text-sys3 {
  font-size: 14px;
  /* font-weight: bolder; */
  color: #443421;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}
table, thead, td {
  font-size: 14px;
  border: 1px solid rgb(146, 176, 206);
  border-collapse: collapse;
}
table {
  width: 100%;
  border-radius: 8px;
}
tr {
  height: 36px;
}
td {
  text-align: center;
  font-size: 11px;
}
.time-text {
  font-size: 13px;
  color: rgb(67, 116, 167);
  padding: 0px 6px;
}
.time-text-no {
  font-size: 13px;
  color: #cdcdcd;
  padding: 0px 6px;
}
.btn-box {
  background: rgb(29, 115, 180);
  border: none;
  border-radius: 6px;
  padding: 3px 20px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0px 0px 2px 2px #cdcdcd;
}
</style>
